"use strict";

var _require = require('./index-esm'),
    uncontrollable = _require.default,
    useUncontrolled = _require.useUncontrolled;

module.exports = uncontrollable;
module.exports.useUncontrolled = useUncontrolled;
module.exports.uncontrollable = uncontrollable;


//////////////////
// WEBPACK FOOTER
// ./~/react-overlays/~/uncontrollable/index.js
// module id = 805
// module chunks = 0